// import './styles/globals.css'
// import './fonts/font-poppins/Poppins-Regular.otf'
// import './styles/scss/main.scss'
import './styles/globals.less';
import './styles/font.css';
import { ReactNode } from 'react';
import WebFont from 'webfontloader';
import { globalCss, styled } from '@stitches/configed';
import EmptyIcon from '../Common/Icons/EmptyIcon';
import { ConfigProvider } from 'antd';
import { vi_VN } from '../Common/locale';
// import 'moment/locale/vi';

WebFont.load({
  google: {
    families: ['Be Vietnam Pro:100,200,300,400,500,600,700,800,900'],
  },
});
const globalStyles = globalCss({
  body: {
    // overflow: 'hidden',
    fontFamily: "'Be Vietnam Pro'",
    color: '$text1',
  },
});

const EmptyWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  svg: {
    fontSize: 80,
  },
});
const MainWraper = ({ children }: { children: ReactNode }) => {
  globalStyles();
  return (
    <ConfigProvider
      locale={vi_VN}
      renderEmpty={() => (
        <EmptyWrapper>
          <EmptyIcon /> <span>Không có dữ liệu</span>
        </EmptyWrapper>
      )}
    >
      {children}
    </ConfigProvider>
  );
};
export default MainWraper;
